import React, { ReactNode, useEffect, useState } from "react";
import TopNav from "../dashboard/TopNav";
import Sidebar from "../dashboard/Sidebar";
import UnpaidInvoice from "components/dashboard/UnpaidInvoice";
import { InvoiceStatusResponse } from "type/invoice";
import { useGetTransactionsCountQuery } from "services/slices/invoice";
import { AlertBanner } from "components/dashboard/AlertBanner";

interface Props{
    children : ReactNode
}
const DashboardLayout = ({ children }: Props) => {
  const [mobileMenu, setMobileMenu] = useState<boolean>(false);
  const { data } = useGetTransactionsCountQuery<InvoiceStatusResponse>(
    undefined,
    {
      refetchOnMountOrArgChange: true,
      refetchOnFocus: false,
      refetchOnReconnect: true,
    }
  );
  const [banner, setBanner] = useState<string>("");
  const handleClick = () => {
    setMobileMenu(!mobileMenu);
  };

  useEffect(() => {
    localStorage.setItem("set-banner", "yes");
    setBanner(localStorage.getItem("set-banner") || "");
  }, []);

  return (
    <div className="max-h-[100vh] overflow-hidden ">
      <div>{banner === "yes" && <AlertBanner setBanner={setBanner} />}</div>
      {(data?.data.pending > 0 || data?.data.partly_paid > 0) && (
        <UnpaidInvoice pending={data?.data.pending} />
      )}
      <TopNav onClick={handleClick} />
      <div className="flex">
        <div>
          <Sidebar
            hamburger={mobileMenu}
            onClose={handleClick}
            invoicedata={data}
            banner={banner}
          />
        </div>
        <div
          className={`w-full mb-6 ${
            banner === "yes"
              ? data?.data?.pending > 0 || data?.data?.partly_paid > 0
                ? "md:pb-52 pb-72"
                : "pb-24"
              : data?.data?.pending > 0 || data?.data?.partly_paid > 0
              ? "pb-20"
              : ""
          }  md:border-l-[2px] border-[#E4EBF5] 
          max-h-[calc(100vh-80px)]
          overflow-auto`}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default DashboardLayout;
